export default __webpack_public_path__ + "styles/icons/bunsenBurner.svg";